import { Component, Input, OnInit } from '@angular/core';
import { UserInfoModel } from 'src/app/models/users/UserInfoModel';
import { formatDate } from 'src/app/shared/utils/Formatters';

@Component({
  selector: 'work-details',
  templateUrl: './work-details.component.html',
  styleUrls: ['./work-details.component.scss']
})
export class WorkDetailsComponent implements OnInit {

  @Input() user: UserInfoModel;
  @Input() isAdminOrHr: boolean = false;
  formatDateForTable = formatDate;

  constructor() { }

  ngOnInit() { }

}
